import { useEffect } from "react";
import { TFormHookParams, IFormSection } from "../../types/common";
import useGet from "../common/useGet";
import { API_ACCOUNTS_ROLES, API_DISTRICTS, API_WAGES } from "../../utils/apis";
import { addSelectItem, getRegister } from "../../utils/helpers";
import { URL_WAGES } from "../../utils/urls";

const useWagesForm = ({ id, form, updateFormValues }: TFormHookParams = {}) => {
  const isUpdate = !!id;
  const {
    loadData: getDistricts,
    data: districts,
    loading: loadingDistricts,
  } = useGet();
  const { loadData: getRoles, data: roles, loading: loadingRoles } = useGet();

  useEffect(() => {
    if (isUpdate && form) {
      updateFormValues?.({
        ...form,
        district: form.district?.id || form.district,
      });
    }
  }, [form, isUpdate, updateFormValues]);

  useEffect(() => {
    getDistricts({ api: API_DISTRICTS });
    getRoles({ api: API_ACCOUNTS_ROLES });
  }, []);

  const transformFormData = (data: any) => {
    if (!data) return data;

    const transformed = { ...data };

    if (data.district && typeof data.district === "object") {
      transformed.district = data.district.id || data.district;
    }

    return transformed;
  };

  const sections: IFormSection[] = [
    {
      title: "Wage Details",
      fields: [
        {
          field_name: "district",
          type: "select",
          label: "District",
          props: {
            required: isUpdate ? false : true,
            disabled: isUpdate,
          },
          options_data: districts,
          value: form?.district,
          loading: loadingDistricts,
        },
        {
          field_name: "staff_type",
          type: "select",
          label: "Roles",
          props: {
            required: isUpdate ? false : true,
            disabled: isUpdate,
          },
          options_data: roles?.results?.map((sup: any) =>
            addSelectItem({
              label: sup?.name,
              value: sup?.name?.toUpperCase(),
            }),
          ),
          loading: loadingRoles,
        },
        {
          field_name: "commission_percentage",
          type: "number",
          label: "Commission (%)",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
          value: form?.commission,
        },
        {
          field_name: "fixed_wage",
          type: "number",
          label: "Fixed Wage",
          props: {
            required: isUpdate ? false : true,
            min: 0,
          },
          value: form?.fixed_wage,
        },
        {
          field_name: "is_active",
          label: "Status",
          type: "select",
          props: {
            required: isUpdate ? false : true,
            options: [
              { value: true, label: "Active" },
              { value: false, label: "Inactive" },
            ],
          },
        },
      ],
    },
  ];

  const title = "Wages";
  const redirect = getRegister(URL_WAGES);

  const onSubmit = (payload: any) => {
    if (id) {
      return {
        id,
        api: API_WAGES,
        params: {
          ...payload,
        },
      };
    }
    return {
      api: API_WAGES,
      params: {
        ...payload,
      },
    };
  };

  return {
    sections,
    onSubmit,
    title,
    redirect,
    transformFormData,
  };
};

export default useWagesForm;
